import { render, staticRenderFns } from "./EditAdvance.vue?vue&type=template&id=1c768b7b&"
import script from "./EditAdvance.vue?vue&type=script&lang=js&"
export * from "./EditAdvance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports